import { Operator } from "./operator";
import { UserGroup } from "./user-group";
import { UserAccount } from './user-account';

export class VendorOrganizationUser {
  userTypeId: number = null;
  organizationId: number = null;
  firstName: string = null;
  lastName: string = null;
  phoneNumber: string = null;
  emailAddress: string = null;
  active = true;
  superUser = false;
  userId: number = null;
  lastLoginDate: Date = null;
  accounts: Array<UserAccount> = [];
  operatorId: string;
  createTime: Date;
  operator: Operator;
  permissions: Array<string> = [];
  groups: Array<UserGroup> = [];

  get fullNameAndEmail(): string {
    return [this.firstName, this.lastName, this.emailAddress].filter(Boolean).join(' ');
  }

  constructor(data: VendorOrganizationUser = null) {
    if (data) {
      this.userTypeId = data.userTypeId;
      this.organizationId = data.organizationId;
      this.firstName = data.firstName;
      this.lastName = data.lastName;
      this.phoneNumber = data.phoneNumber;
      this.emailAddress = data.emailAddress;
      this.active = !!data.active;
      this.superUser = !!data.superUser;
      this.userId = data.userId;
      this.lastLoginDate = data.lastLoginDate;
      this.accounts = data.accounts;
      this.operatorId = data.operatorId;
      this.createTime = data.createTime;
      this.operator = data.operator;
      this.permissions = data.permissions;
      this.groups = data.groups;
    }
  }
}
